import React, { createContext, useContext, useEffect, useMemo, useState } from "react"
import { defaultLanguage, getSiteContent } from "../data/siteContent"

const STORAGE_KEY = "emlak-language"

const LanguageContext = createContext(null)

const getInitialLanguage = (initialLanguage) => {
  if (typeof window === "undefined") {
    return initialLanguage || defaultLanguage
  }

  const savedLanguage = window.localStorage.getItem(STORAGE_KEY)

  return savedLanguage || initialLanguage || defaultLanguage
}

export const LanguageProvider = ({ children, language: initialLanguage = defaultLanguage }) => {
  const [language, setLanguage] = useState(() => getInitialLanguage(initialLanguage))

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, language)
    document.documentElement.lang = language
  }, [language])

  const content = useMemo(() => getSiteContent(language), [language])

  useEffect(() => {
    document.title = content.meta.title

    const descriptionTag = document.querySelector('meta[name="description"]')

    if (descriptionTag) {
      descriptionTag.setAttribute("content", content.meta.description)
    }
  }, [content])

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      content,
    }),
    [content, language]
  )

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)

  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider")
  }

  return context
}
